import { render } from "./profile-settings.vue?vue&type=template&id=721e0f9a&scoped=true"
import script from "./profile-settings.vue?vue&type=script&lang=js"
export * from "./profile-settings.vue?vue&type=script&lang=js"

import "./profile-settings.vue?vue&type=style&index=0&id=721e0f9a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721e0f9a"]])

export default __exports__